import { useTranslation } from "react-i18next";
import { REWAMP_LOCALE_NAMESPACE } from "./constants";
import { isRewampKey } from "./keyGrammar";

const isDev = process.env.NODE_ENV !== "production";

// Dev-only guards (grammar + missing entry) warn, never throw.
export const useRewampT = () => {
  const { t, i18n } = useTranslation(REWAMP_LOCALE_NAMESPACE);

  if (!isDev) {
    return (key, defaultValue, options) => t(key, { defaultValue, ...options });
  }

  return (key, defaultValue, options) => {
    if (!isRewampKey(key)) {
      // eslint-disable-next-line no-console
      console.warn(`[rewamp-localisation] "${key}" is not <COMPONENT>.<ELEMENT> SCREAMING_SNAKE — see keyGrammar.js.`);
    }
    const hasEntry = i18n.exists(key, { ns: REWAMP_LOCALE_NAMESPACE });
    if (!hasEntry && defaultValue === undefined) {
      // eslint-disable-next-line no-console
      console.warn(
        `[rewamp-localisation] missing seed/CMS entry and no defaultValue for "${key}" — add it to seedBundles/ or pass a defaultValue.`
      );
    }
    return t(key, { defaultValue, ...options });
  };
};
